module.exports = __webpack_public_path__ + "media/images/png/bg-success-446d2d5a2299989f75a554d3a51cfb73.png";